// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"a715699e","297":"ddb6a4c0","470":"ce7568d2","557":"ba37602e","586":"e0548263"}[chunkId] + ".chunk.js";
};